import { render, staticRenderFns } from "./pro-section.vue?vue&type=template&id=6ed7bab6&scoped=true&"
import script from "./pro-section.vue?vue&type=script&lang=js&"
export * from "./pro-section.vue?vue&type=script&lang=js&"
import style0 from "./pro-section.vue?vue&type=style&index=0&id=6ed7bab6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed7bab6",
  null
  
)

export default component.exports